define(["esri/views/MapView","esri/Map","esri/geometry/Point","esri/geometry/ScreenPoint","esri/geometry/SpatialReference"], function(__WEBPACK_EXTERNAL_MODULE_395__, __WEBPACK_EXTERNAL_MODULE_934__, __WEBPACK_EXTERNAL_MODULE_935__, __WEBPACK_EXTERNAL_MODULE_936__, __WEBPACK_EXTERNAL_MODULE_937__) { return webpackJsonp([1],{

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(1), __webpack_require__(934)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, Map) {
    "use strict";
    var MapService = (function () {
        function MapService() {
            this.map = new Map({
                basemap: 'topo'
            });
        }
        return MapService;
    }());
    MapService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [])
    ], MapService);
    exports.MapService = MapService;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 395:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_395__;

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(1), __webpack_require__(101), __webpack_require__(257), __webpack_require__(931), __webpack_require__(933), __webpack_require__(393), __webpack_require__(932)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, platform_browser_1, http_1, app_component_1, map_component_1, map_service_1, coordinate_component_1) {
    "use strict";
    var AppModule = (function () {
        function AppModule() {
        }
        return AppModule;
    }());
    AppModule = __decorate([
        core_1.NgModule({
            imports: [
                platform_browser_1.BrowserModule,
                http_1.HttpModule
            ],
            declarations: [
                app_component_1.AppComponent,
                map_component_1.MapComponent,
                coordinate_component_1.CoordinateComponent
            ],
            bootstrap: [
                app_component_1.AppComponent
            ],
            providers: [
                map_service_1.MapService
            ]
        }),
        __metadata("design:paramtypes", [])
    ], AppModule);
    exports.AppModule = AppModule;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(661)();
// imports


// module
exports.push([module.i, ":host{position:absolute;bottom:10px;left:6px;z-index:1;font-size:.9em}#cordContainer>p{margin:0}#coordContainer>p:first-child{margin-top:0;margin-bottom:6px}#coordinatesLine,#scaleLine{color:#fff;text-shadow:#000 0 0 5px,#000 0 0 5px,#000 0 0 5px}", ""]);

// exports


/***/ }),

/***/ 661:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),

/***/ 662:
/***/ (function(module, exports) {

module.exports = "<esri-map #esriMap (viewCreated)=\"onViewCreated()\">\n  <coordinate [map-view]=\"esriMap.mapView\"></coordinate>\n</esri-map>";

/***/ }),

/***/ 663:
/***/ (function(module, exports) {

module.exports = "<div id=\"coordContainer\">\n  <p id=\"scaleLine\">\n    Level: <i id=\"zoom\">{{mapView.zoom  | number:'.0-0'}}</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Scale: <i id=\"scale\">{{mapView.scale | number:'.0-0'}}</i>\n  </p>\n  <p id=\"coordinatesLine\">\n    Lat: <i id=\"longitude\">{{longitude | number:'.6-6'}}</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Lon: <i id=\"latitude\">{{latitude | number:'.6-6'}}</i>\n  </p>\n</div>";

/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(660);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1) {
    "use strict";
    var AppComponent = (function () {
        function AppComponent() {
        }
        AppComponent.prototype.ngOnInit = function () {
        };
        AppComponent.prototype.onViewCreated = function () {
            console.log('view created');
        };
        return AppComponent;
    }());
    AppComponent = __decorate([
        core_1.Component({
            selector: 'my-app',
            template: __webpack_require__(662)
        }),
        __metadata("design:paramtypes", [])
    ], AppComponent);
    exports.AppComponent = AppComponent;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 932:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(1), __webpack_require__(395), __webpack_require__(936)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, MapView, ScreenPoint) {
    "use strict";
    var CoordinateComponent = (function () {
        function CoordinateComponent() {
            this._longitude = 0;
            this._latitude = 0;
        }
        Object.defineProperty(CoordinateComponent.prototype, "longitude", {
            get: function () { return this._longitude; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CoordinateComponent.prototype, "latitude", {
            get: function () { return this._latitude; },
            enumerable: true,
            configurable: true
        });
        CoordinateComponent.prototype.ngOnInit = function () {
            this.mapViewElement = this.mapView.container;
            this.mapViewElement.addEventListener('mousemove', this);
        };
        CoordinateComponent.prototype.ngOnDestroy = function () {
            if (this.mapViewElement) {
                this.mapViewElement.removeEventListener('mousemove', this);
            }
        };
        CoordinateComponent.prototype.handleEvent = function (event) {
            switch (event.type) {
                case 'mousemove':
                    this.onMouseMove(event);
                    break;
            }
        };
        CoordinateComponent.prototype.onMouseMove = function (e) {
            var rect = this.mapViewElement.getBoundingClientRect();
            var point = new ScreenPoint({
                x: e.clientX - rect.left,
                y: e.clientY - rect.top
            });
            var mapPoint = this.mapView.toMap(point);
            if (mapPoint !== null) {
                this._longitude = mapPoint.longitude;
                this._latitude = mapPoint.latitude;
            }
        };
        return CoordinateComponent;
    }());
    __decorate([
        core_1.Input('map-view'),
        __metadata("design:type", MapView)
    ], CoordinateComponent.prototype, "mapView", void 0);
    CoordinateComponent = __decorate([
        core_1.Component({
            selector: 'coordinate',
            template: __webpack_require__(663),
            styles: [__webpack_require__(930)]
        }),
        __metadata("design:paramtypes", [])
    ], CoordinateComponent);
    exports.CoordinateComponent = CoordinateComponent;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(1), __webpack_require__(393), __webpack_require__(395), __webpack_require__(935), __webpack_require__(937)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, map_service_1, MapView, Point, SpatialReference) {
    "use strict";
    var MapComponent = (function () {
        function MapComponent(mapService, elementRef) {
            this.mapService = mapService;
            this.elementRef = elementRef;
            this.viewCreated = new core_1.EventEmitter();
        }
        MapComponent.prototype.ngOnInit = function () {
            this.mapView = new MapView({
                container: this.elementRef.nativeElement.firstChild,
                map: this.mapService.map,
                center: new Point({
                    x: -82.44,
                    y: 35.61,
                    spatialReference: new SpatialReference({ wkid: 4326 })
                }),
                zoom: 14
            });
            this.viewCreated.next(this.mapView);
        };
        return MapComponent;
    }());
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], MapComponent.prototype, "viewCreated", void 0);
    MapComponent = __decorate([
        core_1.Component({
            selector: 'esri-map',
            template: '<div id="viewDiv" style="height:100%"><ng-content></ng-content></div>'
        }),
        __metadata("design:paramtypes", [map_service_1.MapService,
            core_1.ElementRef])
    ], MapComponent);
    exports.MapComponent = MapComponent;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 934:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_934__;

/***/ }),

/***/ 935:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_935__;

/***/ }),

/***/ 936:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_936__;

/***/ }),

/***/ 937:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_937__;

/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(173), __webpack_require__(400)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, platform_browser_dynamic_1, app_module_1) {
    "use strict";
    platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ })

},[938])});;


// WEBPACK FOOTER //
// dist/main.bundle.js